<i
  class="pi cursor-pointer table-toggler {{ !color ? 'text-color hover:frm-color-blue-light' : '' }}"
  [style.color]="color"
  [style.font-size.rem]="fontSize"
  [class.pi-minus]="isShow"
  [class.pi-plus]="!isShow"
  (click)="click($event)"></i>
